import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { environment } from 'src/environments/environment';
import { HubConnection } from '@aspnet/signalr';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user/user.service';


@Injectable({
    providedIn: 'root'
})
export class ApportisHubService {

    constructor(private userService: UserService) {

    }
    onMessageReceived = new EventEmitter<any>();
    private _connection: HubConnection;

    private _isConnected: boolean;
    public get isConnected(): boolean {
        return this._isConnected;
    }


    private connectLoader = new BehaviorSubject<any>(false);
    public connected = this.connectLoader.asObservable();

    public get connection(): HubConnection {
        return this._connection;
    }

    public iniitializeHub(reconnectOnError: boolean = true) {
        this._isConnected = false;
        let url = environment.hubUrl;
        if (localStorage.getItem('AuthToken')) {
            url = url + '?token=' + localStorage.getItem('AuthToken');
        }
        const protocol = new signalR.JsonHubProtocol();
        this._connection = new signalR.HubConnectionBuilder()
            .withUrl(url)
            // .configureLogging(signalR.LogLevel.Information)
            // .withHubProtocol(protocol)
            .build();
        this._connection.start().then(() => {
            if ((this._connection as any).connection.transport.webSocket != undefined) {
                const signlRurl = (this._connection as any).connection.transport.webSocket.url;
                const connectionId = this.getParameterByName('id', signlRurl);
                console.log('Connection initialized....');
                // Registered to the user
                this.userService.createConnection(connectionId).subscribe(info => {
                    if (info) {
                        this._isConnected = true;
                        this.connectLoader.next(true);
                    }
                });
            } else {
                setTimeout(() => {
                    this.iniitializeHub(reconnectOnError);
                }, 1000);
            }
            this._connection.onclose(error => {
                if (this._isConnected && reconnectOnError) {
                    setTimeout(() => {
                        console.log(error);
                        this.iniitializeHub(reconnectOnError);
                    }, 1000);
                }
            });
        }, (reason) => {
            if (reconnectOnError || this._isConnected == false) {
                console.log(reason);
                setTimeout(() => {
                    this.iniitializeHub(reconnectOnError);
                }, 1000);
            }
        });
    }
    public getParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    public sendMessage(event: string, data?: any) {
        if (this._connection) {
            if (data) {
                this._connection.invoke(event, data);
            } else {
                this._connection.invoke(event);
            }
        }
    }

    public closeConenction(id?) {
        if (this._isConnected != undefined) {
            this._isConnected = false;
        }
        if (this._connection != undefined) {
            // unregistered to the user
            this.userService.deleteConnection(id).subscribe(info => {
                if (info) {
                    //   this._connection.invoke('UnRegisterUser');
                    this._connection.stop();
                }
            });

        }
    }


}
